import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';
import MobileNav from './components/MobileNav';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Schedule from './pages/Schedule';
import TopicsList from './pages/TopicsList';
import AddTopic from './pages/AddTopic';
import TopicDetail from './pages/TopicDetail';
import Analytics from './pages/Analytics';
import CalendarView from './pages/CalendarView';
import Settings from './pages/Settings';
import ScheduleManager from './pages/ScheduleManager';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import YearlyPlanner from './components/YearlyPlanner';
import './App.css';

// Layout para páginas protegidas com navegação
function AppLayout({ children }) {
  return (
    <>
      <MobileNav />
      {children}
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <Dashboard />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              
              <Route
                path="/schedule"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <Schedule />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/schedule/manage"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <ScheduleManager />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
            
              <Route
                path="/topics"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <TopicsList />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
            
              <Route
                path="/topics/new"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <AddTopic />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
            
              <Route
                path="/topics/:id"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <TopicDetail />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
            
              <Route
                path="/analytics"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <Analytics />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
            
              <Route
                path="/calendar"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <CalendarView />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
            
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <Settings />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
            
              <Route
                path="/planner"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <YearlyPlanner />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
            </Routes>
            <Toaster position="top-center" richColors />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
